module.exports = __webpack_public_path__ + "static/stimwell-web-d1003acb4c3b8344ee365bd7ac73fcde.jpg";